import { render } from "./WaitForgetPassword.vue?vue&type=template&id=cddb1684"
import script from "./WaitForgetPassword.vue?vue&type=script&lang=js"
export * from "./WaitForgetPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__